const normalizeMediaType = (attachment = {}) => String(
  attachment?.mimeType || attachment?.contentType || attachment?.type || ''
).trim().toLowerCase();

const isAudioAttachment = (attachment = {}) => {
  const mediaType = normalizeMediaType(attachment);
  const url = String(attachment?.url || '').toLowerCase();
  return mediaType === 'audio'
    || mediaType.startsWith('audio/')
    || /\.(webm|m4a|mp3|wav|aac|ogg)(?:\?|$)/i.test(url);
};

const isImageAttachment = (attachment = {}) => {
  if (isAudioAttachment(attachment)) return false;
  const mediaType = normalizeMediaType(attachment);
  return mediaType === 'image' || mediaType.startsWith('image/');
};

export const partitionCaptureAttachments = (attachments = []) => (
  (Array.isArray(attachments) ? attachments : []).reduce((result, attachment) => {
    if (!attachment?.url) return result;
    if (isAudioAttachment(attachment)) result.audioAttachments.push(attachment);
    else if (isImageAttachment(attachment)) result.imageAttachments.push(attachment);
    else result.documentAttachments.push(attachment);
    return result;
  }, { imageAttachments: [], audioAttachments: [], documentAttachments: [] })
);

export const buildCaptureBundle = ({
  childId = '',
  selectedDate = null,
  selectedTime = '',
  text = '',
  photoFile = null,
  audioBlob = null,
  photoIntent = '',
} = {}) => ({
  childId,
  selectedDate,
  selectedTime,
  text: String(text || ''),
  photoFile,
  audioBlob,
  photoIntent,
});

export const buildCaptureBundleSourceText = ({
  caregiverText = '',
  voiceTranscript = '',
} = {}) => {
  const cleanCaregiverText = String(caregiverText || '').trim();
  const cleanVoiceTranscript = String(voiceTranscript || '').trim();

  if (!cleanCaregiverText) return cleanVoiceTranscript;
  if (!cleanVoiceTranscript || cleanVoiceTranscript === cleanCaregiverText) return cleanCaregiverText;

  return `${cleanCaregiverText}\n\nVoice transcript:\n${cleanVoiceTranscript}`;
};
